import type { AnexoDialogMensagens } from "./types-anexo-dialog";

export const ANEXO_DROP_TITLE = "Arraste e solte seu arquivo aqui";
/** Figma mobile (13992:358317): sem arrastar, o texto convida ao toque. */
export const ANEXO_DROP_TITLE_MOBILE = "Toque para escolher um arquivo";
export const ANEXO_ESCOLHER_LABEL = "Escolher arquivo";
export const ANEXO_REMOVER_ESCOLHIDO_LABEL = "Remover arquivo escolhido";
export const ANEXO_DIALOG_CANCELAR_LABEL = "Cancelar";
export const ANEXO_DIALOG_SALVAR_LABEL = "Salvar";
export const ANEXO_TEST_ID_PADRAO = "anexo";

export const ANEXO_MENSAGENS_PADRAO: AnexoDialogMensagens = {
  identificacaoObrigatoria: "Informe a identificação do documento.",
  identificacaoMax: (max) => `Máximo de ${max} caracteres.`,
  arquivoObrigatorio: "Selecione um arquivo.",
  formatoInvalido: "Formato de arquivo não aceito.",
  tamanhoInvalido: (nome, tamanho, maxMb) =>
    `${nome} tem ${tamanho}. Envie um arquivo de até ${maxMb} MB.`,
};
